module.exports = __webpack_public_path__ + "img/1.2416d396.jpg";